var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFourthCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 953,
    height: 954,
    viewBox: "0 0 953 954",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.519 951.55C738.483 951.55 950.846 739.186 950.846 477.223C950.846 215.259 738.483 2.89565 476.519 2.89565C214.556 2.89565 2.19204 215.259 2.19204 477.223C2.19204 739.186 214.556 951.55 476.519 951.55ZM476.519 953.52C739.571 953.52 952.817 740.275 952.817 477.223C952.817 214.171 739.571 0.925293 476.519 0.925293C213.467 0.925293 0.22168 214.171 0.22168 477.223C0.22168 740.275 213.467 953.52 476.519 953.52Z",
    fill: "#D7544F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M925.3 474.251L951.143 474.109L951.148 475.06L925.305 475.202L925.3 474.251Z",
    fill: "url(#paint0_linear_499_1648)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_499_1648",
    x1: 476.519,
    y1: 0.925293,
    x2: 476.519,
    y2: 953.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthCircle);
export default __webpack_public_path__ + "static/media/fourth-circle.362055ee3f1c39ec41acbc23fdc5b3d1.svg";
export { ForwardRef as ReactComponent };